import React, { useState } from "react"
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Link } from "gatsby"


const KeyCoverage = ({ lang }) => {
  const [ttOpen, setTtOpen] = useState(false)
  const toogle = () => {
    setTtOpen(val => !val)
  }

  const [ttOpenA1, setTtOpenA1] = useState(false)
  const [ttOpenA2, setTtOpenA2] = useState(false)
  const [ttOpenA3, setTtOpenA3] = useState(false)

  const [ttOpenB1, setTtOpenB1] = useState(false)
  const [ttOpenB2, setTtOpenB2] = useState(false)
  const [ttOpenB3, setTtOpenB3] = useState(false)

  const [ttOpenC1, setTtOpenC1] = useState(false)
  const [ttOpenC2, setTtOpenC2] = useState(false)
  const [ttOpenC3, setTtOpenC3] = useState(false)

  const [isOpenedEliteA, setIsOpenedEliteA] = useState(true);
  const [isOpenedEliteB, setIsOpenedEliteB] = useState(false);
  const [isOpenedEliteC, setIsOpenedEliteC] = useState(false);

  const toogle1 = () => {
    if (isOpenedEliteA) {
      setTtOpenA1(true)
      setTtOpenA2(false)
      setTtOpenA3(false)
    }
    if (isOpenedEliteB) {
      setTtOpenB1(true)
      setTtOpenB2(false)
      setTtOpenB3(false)
    }
    if (isOpenedEliteC) {
      setTtOpenC1(true)
      setTtOpenC2(false)
      setTtOpenC3(false)
    }
  }

  const toogle2 = () => {
    if (isOpenedEliteA) {
      setTtOpenA2(true)
      setTtOpenA1(false)
      setTtOpenA3(false)
    }
    if (isOpenedEliteB) {
      setTtOpenB2(true)
      setTtOpenB1(false)
      setTtOpenB3(false)
    }
    if (isOpenedEliteC) {
      setTtOpenC2(true)
      setTtOpenC1(false)
      setTtOpenC3(false)
    }
  }

  const toogle3 = () => {
    if (isOpenedEliteA) {
      setTtOpenA3(true)
      setTtOpenA1(false)
      setTtOpenA2(false)
    }
    if (isOpenedEliteB) {
      setTtOpenB3(true)
      setTtOpenB1(false)
      setTtOpenB2(false)
    }
    if (isOpenedEliteC) {
      setTtOpenC3(true)
      setTtOpenC1(false)
      setTtOpenC2(false)
    }
  }

  const handleEliteA = e => {
    setTtOpenA1(false)
    setTtOpenA2(false)
    setTtOpenA3(false)
    setTtOpenB1(false)
    setTtOpenB2(false)
    setTtOpenB3(false)
    setTtOpenC1(false)
    setTtOpenC2(false)
    setTtOpenC3(false)
    setIsOpenedEliteA(true)
    setIsOpenedEliteB(false)
    setIsOpenedEliteC(false)
  };

  const handleEliteB = e => {
    setTtOpenA1(false)
    setTtOpenA2(false)
    setTtOpenA3(false)
    setTtOpenB1(false)
    setTtOpenB2(false)
    setTtOpenB3(false)
    setTtOpenC1(false)
    setTtOpenC2(false)
    setTtOpenC3(false)
    setIsOpenedEliteA(false)
    setIsOpenedEliteB(true)
    setIsOpenedEliteC(false)
  };

  const handleEliteC = e => {
    setTtOpenA1(false)
    setTtOpenA2(false)
    setTtOpenA3(false)
    setTtOpenB1(false)
    setTtOpenB2(false)
    setTtOpenB3(false)
    setTtOpenC1(false)
    setTtOpenC2(false)
    setTtOpenC3(false)
    setIsOpenedEliteA(false)
    setIsOpenedEliteB(false)
    setIsOpenedEliteC(true)
  };


  return <>



    <div className="keycoverage-bg mt-5">
      <div className="container">
        <div className="row">
          <div className="text-center col-md-8 mb-5 offset-md-2">
            <h2 className="main-title ">{lang.keyCoverage.title}</h2>
            <div className="mt-2 sub-title">{lang.keyCoverage.desc}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 offset-md-3 navi">
            <div className={isOpenedEliteA ? "btn_navi active" : "btn_navi"} onClick={handleEliteA}>{lang.keyCoverage.eliteA}</div>
            <div className={isOpenedEliteB ? "btn_navi active" : "btn_navi"} onClick={handleEliteB}>{lang.keyCoverage.eliteB}</div>
            <div className={isOpenedEliteC ? "btn_navi active" : "btn_navi"} onClick={handleEliteC}>{lang.keyCoverage.eliteC}</div>
          </div>
        </div>

        {/* ELITE A */}
        {isOpenedEliteA && (
          <div className="row mt-5 ">
            <div className="col-md-6 col-lg-8 plan_a-bg">
              <div className=" plan_position-1">
                <button type="button" id="Popover1" onClick={toogle1} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage1sub1_1} &amp; {lang.keyCoverage.coverage1sub1_2}
                </button>
              </div>
              <div className=" plan_position-2">
                <button type="button" id="Popover2" onClick={toogle2} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage2sub1}
                </button>
              </div>
              <div className=" plan_position-3">
                <button type="button" id="Popover3" onClick={toogle3} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage3sub1}
                </button>
              </div>

              <Popover placement="bottom" isOpen={ttOpenA1} toggle={toogle1} target="Popover1">
                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage1Dropdown1}</div>
                  <div >
                    <div className="mt-2">{lang.elitePlan.upTo70Years}: <br /><span className="keycoverage_tx-highlight">RM 500,000</span></div>
                    <div className="mt-2">{lang.elitePlan.above70Years}: <br /><span className="keycoverage_tx-highlight">RM 150,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>

              <Popover placement="bottom" isOpen={ttOpenA2} toggle={toogle2} target="Popover2">
                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage2sub1}</div>
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage2Dropdown1} <br /><span className="keycoverage_tx-highlight">RM 250,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>

              <Popover placement="bottom" isOpen={ttOpenA3} toggle={toogle3} target="Popover3">
                <PopoverBody>
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage3sub1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                    <div className="mt-2">{lang.keyCoverage.coverage3Dropdown1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                  </div>
                </PopoverBody>
              </Popover>

            </div>
            <div className="col-md-6 col-lg-4 mb-5">
              <div className="plan_container">
                <div className="main-title mt-3">{lang.keyCoverage.eliteA}</div>
                <div className="mt-3 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage1} <br /><span className="bold plan_price">RM 500,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage2} <br /><span className="bold plan_price">RM 250,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage3} <br /><span className="bold plan_price">{lang.keyCoverage.unlimited}</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage4_1} <br /><span className="bold plan_price">{lang.keyCoverage.coverage4_2}</span></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* END ELITE A */}

        {/* ELITE B */}
        {isOpenedEliteB && (
          <div className="row mt-5 ">
            <div className="col-md-6 col-lg-8 plan_b-bg">
              <div className=" plan_position-1">
                <button type="button" id="Popover4" onClick={toogle1} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage1sub1_1} &amp; {lang.keyCoverage.coverage1sub1_2}
                </button>
              </div>
              <div className=" plan_position-2">
                <button type="button" id="Popover5" onClick={toogle2} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage2sub1}
                </button>
              </div>
              <div className=" plan_position-3">
                <button type="button" id="Popover6" onClick={toogle3} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage3sub1}
                </button>
              </div>
              <Popover placement="bottom" isOpen={ttOpenB1} toggle={toogle1} target="Popover4">
                {/* <PopoverHeader>+ Medical, Hospital & Other Expenses</PopoverHeader> */}
                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage1Dropdown1}</div>
                  <div >
                    <div className="mt-2">{lang.elitePlan.upTo70Years}: <br /><span className="keycoverage_tx-highlight">RM 300,000</span></div>
                    <div className="mt-2">{lang.elitePlan.above70Years}: <br /><span className="keycoverage_tx-highlight">RM 100,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>
              <Popover placement="bottom" isOpen={ttOpenB2} toggle={toogle2} target="Popover5">
                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage2sub1}</div>
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage2Dropdown1} <br /><span className="keycoverage_tx-highlight">RM 200,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>
              <Popover placement="bottom" isOpen={ttOpenB3} toggle={toogle3} target="Popover6" >
                <PopoverBody>
                  {/* <div className="mt-2">Emergency Medical Evacuation/Repatriation*</div> */}
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage3sub1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                    <div className="mt-2">{lang.keyCoverage.coverage3Dropdown1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                  </div>
                </PopoverBody>
              </Popover>
            </div>
            <div className="col-md-6 col-lg-4 mb-5">
              <div className="plan_container">
                <div className="main-title mt-3">{lang.keyCoverage.eliteB}</div>
                <div className="mt-3 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage1} <br /><span className="bold plan_price">RM 300,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage2} <br /><span className="bold plan_price">RM 200,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage3} <br /><span className="bold plan_price">{lang.keyCoverage.unlimited}</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage4_1} <br /><span className="bold plan_price">{lang.keyCoverage.coverage4_2}</span></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* END ELITE B */}

        {/* ELITE C */}
        {isOpenedEliteC && (
          <div className="row mt-5 ">
            <div className="col-md-6 col-lg-8 plan_c-bg">
              <div className=" plan_position-1">
                <button type="button" id="Popover7" onClick={toogle1} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage1sub1_1} &amp; {lang.keyCoverage.coverage1sub1_2}
                </button>
              </div>
              <div className=" plan_position-2">
                <button type="button" id="Popover8" onClick={toogle2} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage2sub1}
                </button>
              </div>
              <div className=" plan_position-3">
                <button type="button" id="Popover9" onClick={toogle3} className="btn btn_pophover clearfix">
                  <span className="plus">+</span> {lang.keyCoverage.coverage3sub1}
                </button>
              </div>



              <Popover placement="bottom" isOpen={ttOpenC1} toggle={toogle1} target="Popover7" >

                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage1Dropdown1} </div>
                  <div >
                    <div className="mt-2">{lang.elitePlan.upTo70Years}: <br /><span className="keycoverage_tx-highlight">RM 150,000</span></div>
                    <div className="mt-2">{lang.elitePlan.above70Years}: <br /><span className="keycoverage_tx-highlight">RM 75,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>
              <Popover placement="bottom" isOpen={ttOpenC2} toggle={toogle2} target="Popover8">
                <PopoverBody>
                  <div className="mt-2">{lang.keyCoverage.coverage2sub1}</div>
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage2Dropdown1} <br /><span className="keycoverage_tx-highlight">RM 100,000</span></div>
                  </div>
                </PopoverBody>
              </Popover>
              <Popover placement="bottom" isOpen={ttOpenC3} toggle={toogle3} target="Popover9">
                <PopoverBody>
                  {/* <div className="mt-2">Emergency Medical Evacuation/Repatriation*</div> */}
                  <div >
                    <div className="mt-2">{lang.keyCoverage.coverage3sub1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                    <div className="mt-2">{lang.keyCoverage.coverage3Dropdown1} <br /><span className="keycoverage_tx-highlight">{lang.keyCoverage.unlimited}</span></div>
                  </div>
                </PopoverBody>
              </Popover>
            </div>
            <div className="col-md-6 col-lg-4 mb-5">
              <div className="plan_container">
                <div className="main-title mt-3">{lang.keyCoverage.eliteC}</div>
                <div className="mt-3 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage1} <br /><span className="bold plan_price">RM 150,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage2} <br /><span className="bold plan_price">RM 100,000</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico_tick-benefits.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage3} <br /><span className="bold plan_price">{lang.keyCoverage.unlimited}</span></div>
                </div>
                <div className="mt-4 left">
                  <div className="left_ico"><img src={"/securetravel/images/ico-cross.svg"} alt="Emergency medical evacuation benefits" /></div>
                  <div className="left_tx">{lang.keyCoverage.coverage4_1} <br /><span className="bold plan_price">{lang.keyCoverage.coverage4_3}</span></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* END ELITE C */}

      </div>
    </div>
  </>
}
export default KeyCoverage